// extracted by mini-css-extract-plugin
export default {"wrapper":"CallStudioPlayer_wrapper__AhdGk","number":"CallStudioPlayer_number__kcVbA"};